<div class="contenitore" *ngIf="data">
  <div class="top-data">
    <div class="img-placeholder" >
      <img [src]="'https://play.vidyard.com/'+category?.videos[0]?.i18nvideoId[translate.currentLang.toUpperCase()]+'.jpg'"
      data-v="4" data-type="inline" />
    </div>
    <div class="banner-info">
      <h1>{{category.videos[0].i18nName[translate.currentLang.toUpperCase()]}}</h1>
      <p class="date">{{category.videos[0].publishDate | date: 'shortDate'}} - {{category.videos[0].expirationDate | date: 'shortDate'}}</p>
      <p class="description">{{category.videos[0].i18nDescription[translate.currentLang.toUpperCase()]}}</p>
    </div>
  </div>
  <div class="bottom-data">
    <div class="select-challenge">
      <h3>{{"BANNER_CHALLENGE.SELECT_CHALL" | translate}}</h3>
      <ion-spinner name="circular" *ngIf="subCategories.length === 0"></ion-spinner>
      <div class="challenge-box" [class.already-selected]="guiService.lastAcceptedChallenge?.id === item.id" [class.not-selected]="!selectedChallenge || selectedChallenge && item.id !== selectedChallenge.id" *ngFor="let item of subCategories" (click)="selectChallenge(item)">
        <p>{{item.i18nName[translate.currentLang.toUpperCase()]}}</p>
      </div>
    </div>
    <button class="join-btn" [class.disabled]="!selectedChallenge" (click)="startChallenge()">{{"BANNER_CHALLENGE.JOIN_BTN" | translate}}</button>
  </div>
  <div class="snackBar" *ngIf="showSnackBar">
    {{"BANNER_CHALLENGE.CHALL_ACCEPTED" | translate}}
  </div>
</div>
